import { render, staticRenderFns } from "./PrivateBox.vue?vue&type=template&id=1b42a2f4&scoped=true&"
import script from "./PrivateBox.vue?vue&type=script&lang=js&"
export * from "./PrivateBox.vue?vue&type=script&lang=js&"
import style0 from "./PrivateBox.vue?vue&type=style&index=0&id=1b42a2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42a2f4",
  null
  
)

export default component.exports